import { WifiXIcon } from "@phosphor-icons/react";
import { useIntl } from "react-intl";

import PageError from "./PageError";

export const NoNetworkConnectionPageError = () => {
  const intl = useIntl();

  return (
    <PageError
      title={intl.formatMessage({
        id: "noNetworkConnetionErrorTitle",
        defaultMessage: "No Internet Connection",
      })}
      subtitles={[
        intl.formatMessage({
          id: "noNetworkConnetionErrorSubtitle",
          defaultMessage: "Check your connection and try again.",
        }),
      ]}
      back={{
        text: intl.formatMessage({
          id: "backToHome",
          defaultMessage: "Back to home",
        }),
        options: { to: "/" },
      }}
      icon={<WifiXIcon size={60} color="#295942" />}
      hideWhatsAppButton
    />
  );
};
